{
  "title": "Ingresos",
  "menu": "Ingresos",
  "orderContext": "Contexto de ingresos del pedido",
  "sourceCount": "{{count}} registros de ingresos devueltos por contabilidad",
  "priorityMetrics": "Métricas prioritarias",
  "kpi": {
    "netProfit": "Beneficio neto",
    "roi": "Retorno de inversión",
    "collectionRate": "Tasa de cobro de ingresos",
    "freeCashFlow": "Flujo de caja libre",
    "basisNote": "{{basisNote}}",
    "unavailable": "No disponible para este pedido",
    "freeCashFlowContext": "Este modelo de ingresos no incluye una partida separada de capex; el FCF se muestra tal como viene."
  },
  "error": {
    "title": "No se pueden cargar los datos de ingresos",
    "message": "Ocurrió un error al obtener los datos contables de ingresos. Inténtalo de nuevo.",
    "retry": "Intentar de nuevo"
  },
  "missing": {
    "title": "Pedido no encontrado",
    "message": "No se encontraron datos contables del pedido. Vuelve atrás y selecciona un pedido válido.",
    "back": "Volver"
  },
  "noData": {
    "title": "Aún no hay datos de ingresos",
    "message": "Los registros contables de ingresos aún no se han generado para este pedido. Esto suele ocurrir cuando el trabajador de contabilidad todavía no ha procesado esta transacción o el identificador de transacción (tcId) no estaba disponible."
  },
  "metric": {
    "revenueInvoiced": "Ingresos facturados (devengados)",
    "revenueCollected": "Ingresos cobrados (efectivo)",
    "cashConversionContext": "La conversión de efectivo se muestra como porcentaje del modelo."
  },
  "group": {
    "executive": {
      "title": "Métricas ejecutivas",
      "subtitle": "Rendimiento, liquidez, posición del balance y eficiencia operativa."
    },
    "derived": {
      "title": "Métricas derivadas",
      "subtitle": "Indicadores de rentabilidad, cobro, retorno y capital de trabajo proporcionados por contabilidad."
    },
    "base": {
      "title": "Métricas base",
      "subtitle": "Importes registrados de ingresos y costes. Facturado es devengo; cobrado es efectivo."
    }
  },
  "reconciliation": {
    "title": "Conciliación",
    "subtitle": "Las ecuaciones de referencia aclaran los valores de efectivo frente a devengo; aquí no se recalcula nada.",
    "equals": "Igual a",
    "plus": "Más",
    "minus": "Menos",
    "unavailable": "No disponible para este pedido"
  },
  "table": {
    "title": "Detalle de ingresos",
    "subtitle": "Los 23 registros contables de ingresos, referencia auditable",
    "ariaLabel": "Métricas de ingresos de la empresa de títulos",
    "caption": "Métricas de ingresos de la empresa de títulos",
    "posted": "Registrado",
    "unposted": "No registrado",
    "override": "Sobrescritura aplicada",
    "overrideShort": "Sobrescritura",
    "months": "meses",
    "month": "mes",
    "unavailable": "No disponible para este pedido",
    "col": {
      "code": "Código",
      "description": "Descripción",
      "group": "Grupo",
      "amount": "Importe",
      "date": "Fecha",
      "context": "Contexto"
    }
  },
  "groupLabels": {
    "base": "Base",
    "derived": "Derivadas",
    "executive": "Ejecutivas"
  },
  "equations": {
    "revenueInvoicedLabel": "Ingresos facturados (devengados)",
    "revenueCollectedLabel": "Ingresos cobrados (efectivo)",
    "revenuePendingLabel": "Ingresos pendientes",
    "costsIncurredLabel": "Costos incurridos",
    "costsSettledLabel": "Costos liquidados",
    "costsOpenLabel": "Costos abiertos",
    "netProfitLabel": "Beneficio neto",
    "currentAssetsLabel": "Activos corrientes"
  },
  "statesLegacy": {
    "errorTitle": "No se pueden cargar los datos de ingresos"
  }
}
